import React, { Fragment } from "react";
import { Button, Drawer, Form, Input } from "antd";
import DriversTable from "../Drawer/SelectDriver/SelectDriver";

class Drivers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerSelectDriver: this.props.drawerSelectDriver,
      currentDriverDrawer: 1
    };
  }

  selectDriver = rows => {
    const { currentDriverDrawer } = this.state;
    this.props.form.setFieldsValue({
      ["driver" + (currentDriverDrawer > 1 ? currentDriverDrawer : "")]: `${
        rows.lastname ? rows.lastname : ""
      } ${rows.name ? rows.name[0] + "." : ""} ${
        rows.patronymic ? rows.patronymic[0] + "." : ""
      }`,
      ["driver" +
      (currentDriverDrawer > 1 ? currentDriverDrawer : "") +
      "Id"]: rows.id
    });
    this.setState({ drawerSelectDriver: false });
  };

  toggleDriverDrawer = (numDriver = null) => {
    this.setState(state => ({
      currentDriverDrawer: !state.drawerSelectDriver
        ? numDriver
        : state.currentDriverDrawer,
      drawerSelectDriver: !state.drawerSelectDriver
    }));
  };

  render() {
    const { disabled } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const isValue = getFieldValue("driverId") || getFieldValue("driver");
    return (
      <Fragment>
        <div className="offer-card__item">
          <span className="label">Водитель:</span>
          <Form.Item className={isValue ? "visible-block" : "hidden-block"}>
            {getFieldDecorator("driver")(
              <Input style={{ width: 368 }} disabled={true} />
            )}
          </Form.Item>
          <Form.Item hidden={true}>
            {getFieldDecorator("driverId")(
              <Input type="hidden" disabled={true} />
            )}
          </Form.Item>
          {disabled && !isValue ? (
            <Input
              style={{ width: 224 }}
              type="text"
              disabled={true}
              placeholder="не указано"
            />
          ) : (
            <Button
              style={{ minWidth: 176 }}
              type="primary"
              ghost
              disabled={disabled}
              onClick={this.toggleDriverDrawer.bind(this, 1)}
            >
              {isValue ? "Сменить водителя" : "Выбрать водителя"}
            </Button>
          )}
        </div>
        <Drawer
          title="Выбор водителя"
          placement="left"
          closable={true}
          visible={this.state.drawerSelectDriver}
          onClose={this.toggleDriverDrawer}
          className="select-drawer"
        >
          <DriversTable selectDriver={this.selectDriver} />
        </Drawer>
      </Fragment>
    );
  }
}

export default Drivers;
